import React from 'react';
import PropTypes from 'prop-types';
import WizardInput from '../Input';
import Price from './Price';
import CheckboxComponent from './Checkbox';
import SelectPrice from './SelectPrice';
import Period from './Period';
import StartDate from './StartDate';
import styles from './styles.less';

const PriceComponent = ({
  t,
  updateContent,
  freeCourse,
  price,
  defaultCurrency,
  period,
  localStyles,
  periods,
  periodValue,
  day,
  time,
  schedules,
  currency,
}) => (
  <>
    <WizardInput title={t('wizard.start.date.create')} hint={t('start.date.hint')}>
      <StartDate updateContent={updateContent} day={day} time={time} t={t} schedules={schedules} />
    </WizardInput>
    <WizardInput title={t('course.create.wizard.step3')} hint={t('wizard.hint.price')}>
      <div className={styles.priceShow}>
        <Price
          t={t}
          updateContent={updateContent}
          freeCourse={freeCourse}
          price={price}
          defaultCurrency={defaultCurrency}
          currency={currency}
        />
        <CheckboxComponent
          t={t}
          updateContent={updateContent}
          freeCourse={freeCourse}
          name="wizard_price_free"
        />
      </div>
      <SelectPrice
        t={t}
        period={period}
        updateContent={updateContent}
        freeCourse={freeCourse}
        localStyles={localStyles}
        periods={periods}
        className={styles.selectPriceType}
      />
      <Period
        t={t}
        updateContent={updateContent}
        periodValue={periodValue}
        period={period}
        freeCourse={freeCourse}
      />
    </WizardInput>
  </>
);

PriceComponent.propTypes = {
  updateContent: PropTypes.func,
  t: PropTypes.func,
  freeCourse: PropTypes.bool,
  price: PropTypes.string,
  defaultCurrency: PropTypes.string,
  period: PropTypes.string,
  localStyles: PropTypes.object,
  periods: PropTypes.array,
  periodValue: PropTypes.string,
  day: PropTypes.string,
  time: PropTypes.string,
  schedules: PropTypes.array,
  currency: PropTypes.string,
};

PriceComponent.defaultProps = {
  updateContent: () => {},
  t: () => {},
  freeCourse: null,
  price: '',
  defaultCurrency: '',
  localStyles: {},
  period: '',
  periods: [],
  periodValue: '',
  day: '',
  time: '',
  schedules: [],
  currency: '',
};

export default PriceComponent;
